/* Milk Solutions - Judge.me search/filter toolbar */
(function () {
  function initMilkJudgeMeTools() {
    var widget = document.querySelector('#judgeme_product_reviews .jdgm-rev-widg');
    if (!widget || widget.querySelector('.milk-jdgm-tools')) return false;

    var body = widget.querySelector('.jdgm-rev-widg__body');
    if (!body) return false;

    var tools = document.createElement('div');
    tools.className = 'milk-jdgm-tools';
    tools.innerHTML =
      '<div class="milk-jdgm-search-wrap">' +
        '<input class="milk-jdgm-search" type="search" placeholder="Search Reviews" aria-label="Search reviews">' +
      '</div>' +
      '<select class="milk-jdgm-select milk-jdgm-sort" aria-label="Sort reviews">' +
        '<option value="recent">Most Relevant</option>' +
        '<option value="highest">Highest Rating</option>' +
        '<option value="lowest">Lowest Rating</option>' +
      '</select>' +
      '<select class="milk-jdgm-select milk-jdgm-rating" aria-label="Filter by rating">' +
        '<option value="all">All Ratings</option>' +
        '<option value="5">5 Stars</option>' +
        '<option value="4">4 Stars</option>' +
        '<option value="3">3 Stars</option>' +
        '<option value="2">2 Stars</option>' +
        '<option value="1">1 Star</option>' +
      '</select>' +
      '<button class="milk-jdgm-media" type="button" aria-pressed="false">With Media</button>';

    body.parentNode.insertBefore(tools, body);

    var list = body.querySelector('.jdgm-rev-widg__reviews') || body;
    var noResults = document.createElement('div');
    noResults.className = 'milk-jdgm-no-results';
    noResults.textContent = 'No reviews match your filters.';
    body.appendChild(noResults);

    var search = tools.querySelector('.milk-jdgm-search');
    var rating = tools.querySelector('.milk-jdgm-rating');
    var sort = tools.querySelector('.milk-jdgm-sort');
    var media = tools.querySelector('.milk-jdgm-media');
    var mediaOnly = false;

    function reviews() {
      return Array.prototype.slice.call(list.querySelectorAll('.jdgm-rev'));
    }

    function reviewRating(review) {
      var ratingEl = review.querySelector('[data-score], .jdgm-rev__rating');
      if (!ratingEl) return 0;

      var dataScore = parseInt(ratingEl.getAttribute('data-score'), 10);
      if (dataScore) return dataScore;

      var active = ratingEl.querySelectorAll('.jdgm-star.jdgm--on, .jdgm-star[class*="on"]').length;
      if (active) return active;

      var label = ratingEl.getAttribute('aria-label') || ratingEl.textContent || '';
      var match = label.match(/([1-5])(?:\s|\/| out)/i);
      return match ? parseInt(match[1], 10) : 0;
    }

    function hasMedia(review) {
      return !!review.querySelector(
        '.jdgm-rev__pics, .jdgm-rev__pic-link, .jdgm-rev__video, ' +
        'img.jdgm-rev__pic-img, video, .jdgm-media-fieldset'
      );
    }

    function applyFilters() {
      var q = search.value.trim().toLowerCase();
      var wantedRating = rating.value;
      var visible = 0;

      reviews().forEach(function (review) {
        var text = (review.textContent || '').toLowerCase();
        var score = reviewRating(review);

        var show =
          (!q || text.indexOf(q) !== -1) &&
          (wantedRating === 'all' || score === parseInt(wantedRating, 10)) &&
          (!mediaOnly || hasMedia(review));

        review.style.display = show ? '' : 'none';
        if (show) visible++;
      });

      noResults.classList.toggle('is-visible', visible === 0);
    }

    function applySort() {
      var items = reviews();
      if (sort.value === 'highest') {
        items.sort(function (a, b) { return reviewRating(b) - reviewRating(a); });
      } else if (sort.value === 'lowest') {
        items.sort(function (a, b) { return reviewRating(a) - reviewRating(b); });
      }
      items.forEach(function (review) { list.appendChild(review); });
      applyFilters();
    }

    search.addEventListener('input', applyFilters);
    rating.addEventListener('change', applyFilters);
    sort.addEventListener('change', applySort);

    media.addEventListener('click', function () {
      mediaOnly = !mediaOnly;
      media.classList.toggle('is-active', mediaOnly);
      media.setAttribute('aria-pressed', mediaOnly ? 'true' : 'false');
      applyFilters();
    });

    applyFilters();
    return true;
  }

  if (!initMilkJudgeMeTools()) {
    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      if (initMilkJudgeMeTools() || attempts > 40) clearInterval(timer);
    }, 250);
  }

  document.addEventListener('DOMContentLoaded', initMilkJudgeMeTools);
})();
